export const quizStore = {
    state: {
        displayPartnerSignUpForm: false,
        signUpFormPartner: null,
        signUpFormPartnerPosition: null,
        signUpFromQuiz: null,
        loadQuizFirst: false,
        selectedQuiz: [],
        showQuestionnaire: false,
    },
    showPartnerSignUpForm(partner, index, fromQuiz = false) {
        this.state.displayPartnerSignUpForm = true;
        this.state.signUpFormPartner = partner;
        this.state.signUpFormPartnerPosition = index;
        this.state.signUpFromQuiz = fromQuiz;
    },
    methods: {
        setCategoryQuestionnaire(category, host) {
            if (
                host['has_quiz'] &&
                host['categories_quiz_mapping'] &&
                host['categories_quiz_mapping'][category] &&
                host['categories_quiz_mapping'][category]['quiz_enabled'] &&
                host['categories_quiz_mapping'][category][
                    'questionnaires_id'
                ] &&
                host['questionnaires'] &&
                Object.keys(host['questionnaires']).length > 0
            ) {
                const selectedQuizId =
                    host['categories_quiz_mapping'][category][
                        'questionnaires_id'
                    ];
                const availableQuizIds = Object.keys(host.questionnaires);

                if (availableQuizIds.includes(selectedQuizId.toString())) {
                    this.quizState.selectedQuiz =
                        host.questionnaires[selectedQuizId];
                    this.quizState.showQuestionnaire = this.setShowPopup();
                }
            }
        },
        setShowPopup() {
            const noShowPages = ['faq', 'aboutus', 'imprint', 'privacy'];
            const secondaryPages = ['articles', 'article', 'review'];
            if (noShowPages.includes(this.$router.currentRoute.name)) {
                return false;
            } else if (window.__host__['hide_quizpopup_on_secondary_pages']) {
                return !secondaryPages.includes(this.$router.currentRoute.name);
            }
            return true;
        },
    },
};
